import React from 'react';
const AppearanceIcon = ({ mainBackgroundColor, dividerColor, accentLineColor, backgroundFillColor, headerBarColor }) => {
  return (
    <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 2608661">
        <rect x="1" y="1" width="82.75" height="82.75" stroke={accentLineColor} strokeWidth="2" />
        <g id="1 copy 2">
          <path id="Rectangle_1_copy_8" d="M2 2H82.75V82.75H2V2Z" fill={backgroundFillColor} />
          <path id="Rectangle-path" d="M2 2H82.75V5.1875H2V2Z" fill={headerBarColor} />
          <path
            id="Rectangle_1_copy_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.5625 7.3125H80.625V57.25H45.5625V7.3125Z"
            fill={mainBackgroundColor}
          />
          <path id="Rectangle_1_copy_2" d="M2 7.3125H43.4375V10.5H2V7.3125Z" fill={dividerColor} />
          <path id="Rectangle_1_copy_4-3" d="M2 62.5625H82.75V65.75H2V62.5625Z" fill={dividerColor} />
          <path
            id="Rectangle_1_copy_7"
            d="M4.125 14.75H43.4375V15.8125H4.125V14.75Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_23"
            d="M4.125 68.9375H80.625V70H4.125V68.9375Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_25"
            d="M4.125 74.25H80.625V75.3125H4.125V74.25Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_27"
            d="M4.125 79.5625H80.625V80.625H4.125V79.5625Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_9"
            d="M4.125 21.125H43.4375V22.1875H4.125V21.125Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_11"
            d="M4.125 26.4375H43.4375V27.5H4.125V26.4375Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_13"
            d="M4.125 32.8125H43.4375V33.875H4.125V32.8125Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_15"
            d="M4.125 38.125H43.4375V39.1875H4.125V38.125Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_17"
            d="M4.125 44.5H43.4375V45.5625H4.125V44.5Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_19"
            d="M4.125 49.8125H43.4375V50.875H4.125V49.8125Z"
            fill={accentLineColor}
          />
          <path
            id="Rectangle_1_copy_21"
            d="M4.125 56.1875H43.4375V57.25H4.125V56.1875Z"
            fill={accentLineColor}
          />
        </g>
      </g>
    </svg>
  );
};

export default AppearanceIcon;
